import React from 'react';

const SortList = (props) => {

  const handleSortBy = (e) => {
    if (props.isReady) {
      props.setSortList(e.target.value);
    }
  };

  return (
    <>
      {(props.isReady) && (
        <div className='sort-list-wrapper'>
        <h3 className='filter-label'>{Drupal.t('Sort by')}</h3>
        <div className='sort-list'>
        
          <select onChange={handleSortBy} defaultValue="make">
              <option value="make">{Drupal.t('Make')}</option>
              <option value="type">{Drupal.t('Type')}</option>
              <option value="kw">{Drupal.t('Max kW')}</option>
          </select>
          </div>
        </div>
      )}
    </>
  );
};

export default SortList;